module.exports = __webpack_public_path__ + "img/us.ae65659.svg";